module.exports = __webpack_public_path__ + "static/img/phzf.6bb00be1.png";